import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import { EventBoundary } from './event-boundary';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var withEventBoundary = boundaryProps => WrappedComponent => {
  var mapProps = typeof boundaryProps === 'function' ? boundaryProps : () => typeof boundaryProps === 'string' ? {
    name: boundaryProps
  } : boundaryProps;
  var HoC = props => ___EmotionJSX(EventBoundary, mapProps(props), ___EmotionJSX(WrappedComponent, props));
  setHOCDisplayName(HoC, WrappedComponent, 'withEventBoundary');
  return hoistNonReactStatics(HoC, WrappedComponent);
};